export default {
  props: ['title', 'info', 'fullscreen'],
  computed: {
    item() {
      return this.myOrder.productItem;
    },
    variantId() {
      return this.myOrder.productVariantId;
    },
    variant() {
      return this._.find(this.item.variants, {id: this.variantId});
    },
    carouselView() {
      return this.$store.getters.CAROUSEL_VIEW;
    },
  },
}
